import { FC, Fragment } from 'react';
import CashForm from '../shift/CashForm';
import ShiftForm from '../shift/ShiftForm';
import DiscountsSlideUp from '../slidups/DiscountsSlideUp';
import TicketSaveForm from '../slidups/TicketSaveForm';

interface ModalCompsProps {
  [key: string]: FC<any>;
}

export const comps: ModalCompsProps = {
  FRAGMENT: Fragment,
  START_SHIFT: ShiftForm,
  LOGIN: () => null, // TODO: Implement login form
  REGISTER: () => null, // TODO: Implement register form
  DISCOUNTS: DiscountsSlideUp,
  TICKET_SAVE: TicketSaveForm,
  SEND_EMAIL: () => null, // TODO: Implement send email form
  POS_SETUP: () => null, // TODO: Implement POS setup form
  FORGET_PASSWORD: () => null, // TODO: Implement forget password form
  ITEM_DETAILS: () => null, // TODO: Implement item details form
  ADD_CASH_FORM: CashForm,
};
